import React from 'react';

import LeftArrowSvg from 'assets/images/left-arrow-sm.svg';

import BaseIcon from './BaseIcon';

const LeftArrowSmIcon = props => (
  <BaseIcon {...props} src={LeftArrowSvg} />
);

export default LeftArrowSmIcon;
